import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MobileActionBar from "./components/MobileActionBar";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Realisations from "./pages/Realisations";
import Avis from "./pages/Avis";
import Conseils from "./pages/Conseils";
import Article from "./pages/Article";
import Contact from "./pages/Contact";
import Devis from "./pages/Devis";
import RendezVous from "./pages/RendezVous";
import Ville from "./pages/Ville";
import LocalPage from "./pages/LocalPage";
import Privacy from "./pages/Privacy";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}

function SiteRoutes() {
  useLenis();
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/a-propos" element={<About />} />
      <Route path="/realisations" element={<Realisations />} />
      <Route path="/avis" element={<Avis />} />
      <Route path="/conseils" element={<Conseils />} />
      <Route path="/conseils/:slug" element={<Article />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/demander-un-devis" element={<Devis />} />
      <Route path="/rendez-vous" element={<RendezVous />} />
      <Route path="/jardinier-charleroi" element={<Ville ville="charleroi" />} />
      <Route path="/jardinier-namur" element={<Ville ville="namur" />} />
      <Route path="/jardinier-mons" element={<Ville ville="mons" />} />
      <Route path="/:slug" element={<LocalPage />} />
      <Route path="/politique-de-confidentialite" element={<Privacy />} />
      <Route path="/mentions-legales" element={<Legal />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error("App error:", err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#FAF7F2] text-center px-4">
          <p className="font-serif text-3xl text-[#1E3A2B]">Une erreur est survenue</p>
          <button onClick={() => (window.location.href = "/")} className="mt-6 px-6 py-3 rounded-full bg-[#1E3A2B] text-[#FAF7F2] text-sm font-semibold">
            Recharger le site
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function Shell() {
  const { pathname } = useLocation();
  return (
    <div className="bg-sand min-h-screen">
      <Navbar />
      <ScrollToTop />
      <main>
        <SiteRoutes />
      </main>
      <Footer />
      <MobileActionBar />
      <WhatsAppButton />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Shell />
        <Toaster position="top-center" richColors toastOptions={{ style: { fontFamily: "Plus Jakarta Sans, sans-serif" } }} />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
